import { render } from "./MisTurnos.vue?vue&type=template&id=2363bc07&ts=true"
import script from "./MisTurnos.vue?vue&type=script&lang=ts"
export * from "./MisTurnos.vue?vue&type=script&lang=ts"

import "./MisTurnos.vue?vue&type=style&index=0&id=2363bc07&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__